var _defs, _path, _g, _path2, _path3, _path4, _g2, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDbCropped(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    zoomAndPan: "magnify",
    preserveAspectRatio: "xMidYMid meet",
    viewBox: "296 100.71 350 326.09",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "d1511cfc1d"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 296 324 L 646 324 L 646 426.800781 L 296 426.800781 Z M 296 324 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "cb62224a79"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 296 100.710938 L 646 100.710938 L 646 168 L 296 168 Z M 296 100.710938 ",
    clipRule: "nonzero"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#2f7fc1",
    d: "M 312.039062 309.046875 C 301.84375 313.640625 296.128906 318.75 296.128906 324.144531 C 296.128906 344.15625 374.410156 360.375 470.972656 360.375 C 567.535156 360.375 645.816406 344.15625 645.816406 324.144531 C 645.816406 318.75 640.101562 313.640625 629.90625 309.046875 C 602.277344 321.515625 541.527344 330.183594 470.972656 330.183594 C 400.421875 330.183594 339.671875 321.515625 312.039062 309.046875 Z M 312.039062 309.046875 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#d1511cfc1d)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#4da7ff",
    d: "M 470.972656 360.375 C 374.410156 360.375 296.128906 344.15625 296.128906 324.144531 L 296.128906 390.570312 C 296.128906 410.582031 374.410156 426.800781 470.972656 426.800781 C 567.535156 426.800781 645.816406 410.582031 645.816406 390.570312 L 645.816406 324.144531 C 645.816406 344.15625 567.535156 360.375 470.972656 360.375 Z M 470.972656 360.375 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#2f7fc1",
    d: "M 312.039062 212.425781 C 301.84375 217.023438 296.128906 222.132812 296.128906 227.523438 C 296.128906 247.535156 374.410156 263.757812 470.972656 263.757812 C 567.535156 263.757812 645.816406 247.535156 645.816406 227.523438 C 645.816406 222.132812 640.101562 217.023438 629.90625 212.425781 C 602.277344 224.898438 541.527344 233.5625 470.972656 233.5625 C 400.421875 233.5625 339.671875 224.898438 312.039062 212.425781 Z M 312.039062 212.425781 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#4da7ff",
    d: "M 470.972656 167.136719 C 374.410156 167.136719 296.128906 150.917969 296.128906 130.90625 L 296.128906 197.332031 C 296.128906 202.722656 301.851562 207.832031 312.039062 212.425781 C 339.671875 224.898438 400.421875 233.5625 470.972656 233.5625 C 541.527344 233.5625 602.277344 224.898438 629.90625 212.425781 C 640.097656 207.832031 645.816406 202.722656 645.816406 197.332031 L 645.816406 130.90625 C 645.816406 150.917969 567.535156 167.136719 470.972656 167.136719 Z M 470.972656 167.136719 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#4da7ff",
    d: "M 470.972656 263.757812 C 374.410156 263.757812 296.128906 247.535156 296.128906 227.523438 L 296.128906 293.949219 C 296.128906 299.34375 301.851562 304.453125 312.039062 309.046875 C 339.671875 321.515625 400.421875 330.183594 470.972656 330.183594 C 541.527344 330.183594 602.277344 321.515625 629.90625 309.046875 C 640.097656 304.453125 645.816406 299.34375 645.816406 293.949219 L 645.816406 227.523438 C 645.816406 247.535156 567.535156 263.757812 470.972656 263.757812 Z M 470.972656 263.757812 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cb62224a79)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#7dbfff",
    d: "M 470.972656 100.710938 C 374.410156 100.710938 296.128906 110.890625 296.128906 130.90625 C 296.128906 150.917969 374.410156 167.136719 470.972656 167.136719 C 567.535156 167.136719 645.816406 150.917969 645.816406 130.90625 C 645.816406 110.890625 567.535156 100.710938 470.972656 100.710938 Z M 470.972656 100.710938 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#666666",
    d: "M 489.0625 203.371094 L 452.886719 203.371094 C 449.558594 203.371094 446.855469 200.664062 446.855469 197.332031 C 446.855469 193.996094 449.558594 191.292969 452.886719 191.292969 L 489.0625 191.292969 C 492.390625 191.292969 495.089844 193.996094 495.089844 197.332031 C 495.089844 200.664062 492.390625 203.371094 489.0625 203.371094 Z M 489.0625 203.371094 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#666666",
    d: "M 489.0625 299.988281 L 452.886719 299.988281 C 449.558594 299.988281 446.855469 297.285156 446.855469 293.949219 C 446.855469 290.617188 449.558594 287.910156 452.886719 287.910156 L 489.0625 287.910156 C 492.390625 287.910156 495.089844 290.617188 495.089844 293.949219 C 495.089844 297.285156 492.390625 299.988281 489.0625 299.988281 Z M 489.0625 299.988281 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#666666",
    d: "M 489.0625 396.609375 L 452.886719 396.609375 C 449.558594 396.609375 446.855469 393.902344 446.855469 390.570312 C 446.855469 387.234375 449.558594 384.53125 452.886719 384.53125 L 489.0625 384.53125 C 492.390625 384.53125 495.089844 387.234375 495.089844 390.570312 C 495.089844 393.902344 492.390625 396.609375 489.0625 396.609375 Z M 489.0625 396.609375 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDbCropped);
export default __webpack_public_path__ + "static/media/db-cropped.9944003d90b70b022ea5b5d5d9f055d1.svg";
export { ForwardRef as ReactComponent };